module.exports = __webpack_public_path__ + "img/table-img.9831efe0.png";